import {
  changeUndoRedoList,
  clearUndoRedo,
  pushToUndoStack,
  setCustomBackgroundDict,
  setImageDict,
  setRecentArtDict,
  setSavedArtDict,
  setSelectingTemplateFlag,
  setSharedArtDict,
  setStockArtDict,
  setTextDict,
  setUi,
  updateFirstUndoText,
  updateLastUndoText,
  updatePrevTextDict,
} from '../../actions';
import {
  initializeCategoryDict,
  initializeCommonTemplateDict,
  initializeSpecialTemplateDict,
} from '../../../template/actions';
import { pushToUndoListMode, undoRedoType } from '../../../utils/constants';

import { hideWaitingCover } from '../../../main/actions';
import { isMobileOnly } from 'react-device-detect';
import { setNextgenUi } from '../../../nextgen/actions';
import { setUserImageClone } from '../../../userimage/actions';
import { studioItemType } from '../../../main/constants';
import { updateFullPreview } from '../../../preview/logics';

const getUndoRedoData = (type, store) => {
  // cannot directly assing {} to imageDict in reducer
  const canvasKey = store.ui.currentImprintAreaKey;
  const initImageDict = {};
  initImageDict[canvasKey] = [];

  const initTextDict = Object.assign({}, store.textDict);
  if (store.specs.nextGenUI && type === undoRedoType.Init) {
    Object.keys(store.imprintAreaDict).forEach((element) => {
      if (typeof initTextDict[element] === 'undefined') {
        initTextDict[element] = [];
      }
    });
  }

  const undoRedoData =
    type === undoRedoType.Init
      ? {
          categoryDict: store.categoryDict,
          templateDict: store.templateDict,
          specialTemplateDict: store.specialTemplateDict,
          imageDict: Object.keys(store.imageDict).length === 0 ? initImageDict : store.imageDict,
          textDict: initTextDict,
          customBackgroundDict: store.customBackgroundDict,
          recentArtDict: store.recentArtDict,
          stockArtDict: store.stockArtDict,
          savedArtDict: store.savedArtDict,
          sharedArtDict: store.sharedArtDict,
          userImageClone: store.userImageClone,
        }
      : type === undoRedoType.UploadBackground
      ? {
          categoryDict: store.categoryDict,
          templateDict: store.templateDict,
          specialTemplateDict: store.specialTemplateDict,
          imageDict: store.imageDict,
          customBackgroundDict: store.customBackgroundDict,
        }
      : type === undoRedoType.UploadLogo
      ? {
          imageDict: store.imageDict,
          textDict: store.textDict,
          recentArtDict: store.recentArtDict,
        }
      : type === undoRedoType.SelectStockArt
      ? {
          imageDict: store.imageDict,
          recentArtDict: store.recentArtDict,
          stockArtDict: store.stockArtDict,
          userImageClone: store.userImageClone,
        }
      : type === undoRedoType.SelectSavedArt
      ? {
          imageDict: store.imageDict,
          recentArtDict: store.recentArtDict,
          savedArtDict: store.savedArtDict,
          userImageClone: store.userImageClone,
        }
      : type === undoRedoType.SelectSharedArt
      ? {
          imageDict: store.imageDict,
          recentArtDict: store.recentArtDict,
          sharedArtDict: store.sharedArtDict,
          userImageClone: store.userImageClone,
        }
      : type === undoRedoType.ChangeTemplateOrEditElement || type === undoRedoType.SlideRotateAngle
      ? {
          categoryDict: store.categoryDict,
          templateDict: store.templateDict,
          specialTemplateDict: store.specialTemplateDict,
          imageDict: store.imageDict,
          textDict: store.textDict,
        }
      : type === undoRedoType.SelectElement
      ? {
          imageDict: store.imageDict,
          textDict: store.textDict,
        }
      : {};

  undoRedoData.ui = store.ui;
  undoRedoData.nextgenUi = store.nextgenUi;

  if (type === undoRedoType.ChangeTemplateOrEditElement) {
    const last = store.undoRedoStack?.undoList?.slice(-1);
    if (
      last[0]?.type === undoRedoType.ChangeTemplateOrEditElement &&
      JSON.stringify(last[0]?.textDict) === JSON.stringify(undoRedoData.textDict) &&
      JSON.stringify(last[0]?.imageDict) === JSON.stringify(undoRedoData.imageDict)
    ) {
      return null;
    }
  }

  return undoRedoData;
};

const updateStore = (stackedItem, dispatch, isNextgenUi) => {
  if (stackedItem.categoryDict !== undefined) dispatch(initializeCategoryDict(stackedItem.categoryDict));
  if (stackedItem.templateDict !== undefined) dispatch(initializeCommonTemplateDict(stackedItem.templateDict));
  if (stackedItem.specialTemplateDict !== undefined)
    dispatch(initializeSpecialTemplateDict(stackedItem.specialTemplateDict));
  if (stackedItem.customBackgroundDict !== undefined)
    dispatch(setCustomBackgroundDict(stackedItem.customBackgroundDict));
  if (stackedItem.imageDict !== undefined) dispatch(setImageDict(stackedItem.imageDict));
  if (stackedItem.textDict !== undefined) dispatch(setTextDict(stackedItem.textDict));
  if (stackedItem.recentArtDict !== undefined) dispatch(setRecentArtDict(stackedItem.recentArtDict));
  if (stackedItem.stockArtDict !== undefined) dispatch(setStockArtDict(stackedItem.stockArtDict));
  if (stackedItem.savedArtDict !== undefined) dispatch(setSavedArtDict(stackedItem.savedArtDict));
  if (stackedItem.sharedArtDict !== undefined) dispatch(setSharedArtDict(stackedItem.sharedArtDict));
  if (stackedItem.userImageClone !== undefined) dispatch(setUserImageClone(stackedItem.userImageClone));

  if (stackedItem.ui !== undefined) {
    const waitingCover = Object.assign({}, stackedItem.ui.waitingCover);
    waitingCover.show = false;
    waitingCover.text = '';
    dispatch(setUi({ ...stackedItem.ui, waitingCover }));
  }
  if (stackedItem.nextgenUi !== undefined) {
    dispatch(setNextgenUi({ ...stackedItem.nextgenUi }));
  }

  dispatch(updateFullPreview());
  dispatch(hideWaitingCover());
};

export const undoRedo = (isUndo, undoRedoStack, dispatch, isNextgenUi) => {
  if (isUndo) {
    if (undoRedoStack.undoList.length > 1) {
      const undoList = Object.assign([], undoRedoStack.undoList);
      undoList.pop();
      const last = undoList.pop();
      if (last) {
        updateStore(last, dispatch, isNextgenUi);
        dispatch(changeUndoRedoList(true));
      }
    }
  } else {
    if (undoRedoStack.redoList.length > 0) {
      const redoList = Object.assign([], undoRedoStack.redoList);

      const first = redoList.shift();
      if (first) {
        updateStore(first, dispatch, isNextgenUi);
        dispatch(changeUndoRedoList(false));
      }
    }
  }
};

export const pushToUndoList =
  (type, pushMode = pushToUndoListMode.Normal) =>
  (dispatch, getState) => {
    if (pushMode === pushToUndoListMode.None) return;

    const store = getState();
    if (store.specs.studioItemType === studioItemType.nonDigital) return;
    if (isMobileOnly && !store.specs.nextGenUI) return;

    const data = getUndoRedoData(type, store);
    if (
      type === undoRedoType.SlideRotateAngle &&
      store.undoRedoStack?.undoList?.slice(-1)[0]?.type === undoRedoType.SlideRotateAngle
    ) {
      if (data) dispatch(updatePrevTextDict(data.textDict));
    } else {
      if (data) dispatch(pushToUndoStack({ type, ...data }));
    }
  };

export const updateUndoListRecord =
  (imprintAreaKey, newText, updateLastRecord = false) =>
  (dispatch, getState) => {
    const store = getState();
    if (store.specs.studioItemType === studioItemType.nonDigital) return;
    if (isMobileOnly && !store.specs.nextGenUI) return;

    const canvasKey = imprintAreaKey;
    if (updateLastRecord) dispatch(updateLastUndoText({ canvasKey, text: newText }));
    else dispatch(updateFirstUndoText({ canvasKey, text: newText }));
  };

export const initUndoRedoList = () => (dispatch, getState) => {
  const store = getState();
  if (store.specs.studioItemType === studioItemType.nonDigital) return;
  if (isMobileOnly && !store.specs.nextGenUI) return;

  if (store.ui.isSelectingTemplate) {
    dispatch(setSelectingTemplateFlag(false));
    return;
  }
  dispatch(clearUndoRedo());
  dispatch(pushToUndoList(undoRedoType.Init));
};
